import styled from 'styled-components';
import { FlexibleDiv } from '../../../styled/common';
import { Breakpoints } from '../../../styled/constants';

export const FiltersWrapper = styled(FlexibleDiv)`
  gap: 5px;

  @media (min-width: ${Breakpoints.tablet}px) {
    gap: 10px;
  }

  @media (max-width: ${({ theme }) => theme.tabletBreakpoint}) {
    width: 100%;
    justify-content: space-between;
  }

  @media (min-width: ${Breakpoints.desktop}px) {
    gap: 20px;
  }
`;

export const FilterContent = styled(FlexibleDiv)`
  gap: 5px;

  @media (min-width: ${Breakpoints.tablet}px) {
    gap: 10px;
  }

  @media (min-width: ${Breakpoints.desktop}px) {
    gap: 20px;
  }
`;
